"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.CHAT_FULL_ACCESS = void 0;
var CHAT_FULL_ACCESS = exports.CHAT_FULL_ACCESS = 'CHAT_FULL_ACCESS';